import readRedesignRootAttribute from './readRedesignRootAttribute';

function readRedesignTranslations() {
    return readRedesignRootAttribute('data-redesign-translations');
}

export default readRedesignTranslations;
